import { memo, useContext } from 'react';
// @mui
import { AppBar, Box, BoxProps, Toolbar } from '@mui/material';
import { useTheme } from '@mui/material/styles';
// components
// config
import { HEADER } from '@raas/shared/src/shared-config-global';
// utils
import { NavSectionHorizontal } from '@raas/shared/src/components/minimals/nav-section';
import LegalProvisionContext from '@raas/shared/src/contexts/LegalProvisionContext';
import { bgBlur } from '@raas/shared/src/utils/cssStyles';
import getNavConfig from './config-navigation';

// ----------------------------------------------------------------------

function NavHorizontal() {
  const theme = useTheme();
  const { legalProvisionContext } = useContext(LegalProvisionContext);
  const hasTranslations = legalProvisionContext?.translations?.length > 1;
  return (
    <AppBar
      component="nav"
      color="transparent"
      sx={{
        boxShadow: 0,
        top: HEADER.H_DASHBOARD_DESKTOP_OFFSET,
      }}
    >
      <Toolbar
        sx={{
          ...bgBlur({
            color: theme.palette.background.default,
          }),
        }}
      >
        <NavSectionHorizontal
          data={getNavConfig({ hasVersion: !!legalProvisionContext, hasTranslations })}
        />
      </Toolbar>

      <Shadow />
    </AppBar>
  );
}

export default memo(NavHorizontal);

// ----------------------------------------------------------------------

function Shadow({ sx, ...other }: BoxProps) {
  return (
    <Box
      sx={{
        left: 0,
        right: 0,
        bottom: 0,
        height: 24,
        zIndex: -1,
        width: 1,
        m: 'auto',
        borderRadius: '50%',
        position: 'absolute',
        boxShadow: (theme) => theme.customShadows.z8,
        ...sx,
      }}
      {...other}
    />
  );
}
